// Single source of truth for every app path (Standards.md §3.4).
// Static paths are strings; parameterized paths are builder functions.
// Use ROUTES everywhere you navigate or link; ROUTE_PATTERNS only in <Route path=...>.

export const ROUTES = {
  home: '/',
  discover: '/discover',
  login: '/login',
  signup: '/signup',
  verifyEmail: '/verify-email',
  resetPassword: '/reset-password',
  myBookings: '/my-bookings',
  savedEvents: '/saved-events',
  account: '/account',
  gymDashboard: '/gym-dashboard',
  createEvent: '/create-event',
  profile: '/profile',
  support: '/support',
  openMatEvents: '/openmat-events',
  camp: '/openmat-camp',
  campTerms: '/openmat-camp/terms',
  campBooked: '/openmat-camp/booked',
  terms: '/terms',
  privacy: '/privacy',
  impressum: '/impressum',
  cookies: '/cookies',
  stripeConnectReturn: '/stripe-connect/return',
  stripeConnectRefresh: '/stripe-connect/refresh',

  eventDetail: (slugOrId) => `/event/${slugOrId}`,
  cityEvents: (citySlug) => `/events/${citySlug}`,
  cityDiscipline: (citySlug, discSlug) => `/events/${citySlug}/${discSlug}`,
  editEvent: (id) => `/edit-event/${id}`,
  gymBySlug: (slug) => `/gym/${slug}`,
  profileById: (id) => `/profile/${id}`,
  bookingSuccess: (eventId) =>
    eventId ? `/booking/success?eventId=${encodeURIComponent(eventId)}` : '/booking/success',
  loginWithRedirect: (to) => `/login?redirect=${encodeURIComponent(to)}`,
  signupWithRedirect: (to) => `/signup?redirect=${encodeURIComponent(to)}`,

  admin: {
    hub: '/admin',
    events: '/admin/events',
    ownEvents: '/admin/own-events',
    gyms: '/admin/gyms',
    gymClaims: '/admin/gym-claims',
    gymApprovals: '/admin/gym-approvals',
    incompleteSetups: '/admin/incomplete-setups',
    myClaimedEvents: '/admin/my-claimed-events',
    mergeGyms: '/admin/merge-gyms',
    mergeEvents: '/admin/merge-events',
    importGyms: '/admin/import-gyms',
    matchEvents: '/admin/match-events',
    outreach: '/admin/outreach',
    backfillSchedules: '/admin/backfill-schedules',
    seedIbjjf: '/admin/seed-ibjjf',
    users: '/admin/users',
    // Started life as the weekly events export; now the general export tool.
    // The path stays as-is so existing bookmarks keep working.
    dataExport: '/admin/weekly-export',
  },
};

// React Router path patterns — ONLY for route definitions, never for navigation.
export const ROUTE_PATTERNS = {
  eventDetail: '/event/:slugOrId',
  cityEvents: '/events/:citySlug',
  cityDiscipline: '/events/:citySlug/:disciplineSlug',
  eventDetailLegacy: '/event/:slugOrId/:legacySlug',
  profileById: '/profile/:id',
  gymBySlug: '/gym/:slug',
  editEvent: '/edit-event/:id',
  gymProfileLegacy: '/gym-profile', // redirects to ROUTES.profile
};
